<template>
  <div class="listen-network-player">
    <player
      v-if="urlDataLoaded"
      :podcast-name="podcastName"
      :episode-name="episodeName"
      :episode-description="episodeDescription"
      :episode-audio="episodeAudio"
      :accent-color="accentColor"
    />
  </div>
</template>

<script>
import Player from './Player.vue';

export default {
  name: 'PodcastAd',
  components: {
    Player,
  },
  data() {
    return {
      podcastName: '',
      episodeName: '',
      episodeDescription: '',
      episodeAudio: '',
      accentColor: '',
      urlDataLoaded: false,
    };
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  created() {
    window.addEventListener('message', this.handleMessage);
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);

    this.podcastName = urlParams.get('podcastName');
    this.episodeName = urlParams.get('episodeName');
    this.episodeDescription = urlParams.get('episodeDescription');
    this.episodeAudio = urlParams.get('episodeAudio');
    this.accentColor = urlParams.get('accentColor');

    // Check if episodeAudio is a valid URL and append the parameter
    if (this.episodeAudio) {
      const audioUrl = new URL(this.episodeAudio);
      audioUrl.searchParams.append('_from', 'listennetwork');
      this.episodeAudio = audioUrl.toString();
    }

    this.urlDataLoaded = true;
  },
};

</script>

<style scoped>
/* Sizes supported:
300 × 100: Not supported
320 × 50: Not supported
320 × 100: Not supported
320 × 480: Not supported
300 x 250: In progress
360 × 592: Supported
360 × 640: Supported
375 × 667: Supported
580 x 400: Supported
*/

.listen-network-player {
  display: flex;
  height: 100vh;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
}
</style>
